angular.module('impactx.product').controller('ProductAddToBasketCtrl', [
    'AddToBasketService',
    '$routeParams',
    '$redirect',
    'dataGen',
    ProductAddToBasketCtrl]);

function ProductAddToBasketCtrl(AddToBasketService, $routeParams, $redirect, dataGen)
{
    dataGen.getData({}, {id: $routeParams.id, groupNumber: $routeParams.groupNumber ? $routeParams.groupNumber : 0},
        "/product/viewbasketlink").then(function (data) {
        AddToBasketService.addToBasket(data.data, data.data.basketLink.price.minAmount, null,
            impactX.isDefined(data.data, "basketLink.price.askSupplier"), null).then(function () {
            $redirect.redirectTo(null, "basket");
        }, function () {
            $redirect.redirectTo(null, "basket");
        });
    });
}